import { render, staticRenderFns } from "./userDealer.vue?vue&type=template&id=ebf4f64c"
import script from "./userDealer.vue?vue&type=script&lang=js"
export * from "./userDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports